import { Box, Stack, Typography } from "@mui/material";

interface Props {
	dependencies?: string[];
}

const StandardPlanDependencyCard = ({ dependencies }: Props) => {
	if (!dependencies?.length) {
		return (
			<Typography fontSize={15} color="text.secondary" lineHeight={1.4}>
				None
			</Typography>
		);
	}

	return (
		<Stack direction="row" flexWrap="wrap" gap={0.75}>
			{dependencies.map((dep, index) => (
				<Box
					key={index}
					sx={{
						px: 1.35,
						py: 0.5,
						borderRadius: 1,
						backgroundColor: "#f9fafb",
						fontSize: 14.5,
						fontWeight: 500,
						lineHeight: 1.35,
						color: "#111827",
						whiteSpace: "nowrap",
						boxShadow: "0 1px 1px rgba(0,0,0,0.05)"
					}}
				>
					{dep}
				</Box>
			))}
		</Stack>
	);
};

export default StandardPlanDependencyCard;
